import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../../wayfinder'
/**
* @see \App\Http\Controllers\Admin\Pricing\CompetitorController::index
* @see app/Http/Controllers/Admin/Pricing/CompetitorController.php:33
* @route '/pricing/competitors'
*/
export const index = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

index.definition = {
    methods: ["get","head"],
    url: '/pricing/competitors',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\Pricing\CompetitorController::index
* @see app/Http/Controllers/Admin/Pricing/CompetitorController.php:33
* @route '/pricing/competitors'
*/
index.url = (options?: RouteQueryOptions) => {
    return index.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Pricing\CompetitorController::index
* @see app/Http/Controllers/Admin/Pricing/CompetitorController.php:33
* @route '/pricing/competitors'
*/
index.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Pricing\CompetitorController::index
* @see app/Http/Controllers/Admin/Pricing/CompetitorController.php:33
* @route '/pricing/competitors'
*/
index.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: index.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\Pricing\CompetitorController::index
* @see app/Http/Controllers/Admin/Pricing/CompetitorController.php:33
* @route '/pricing/competitors'
*/
const indexForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Pricing\CompetitorController::index
* @see app/Http/Controllers/Admin/Pricing/CompetitorController.php:33
* @route '/pricing/competitors'
*/
indexForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Pricing\CompetitorController::index
* @see app/Http/Controllers/Admin/Pricing/CompetitorController.php:33
* @route '/pricing/competitors'
*/
indexForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

index.form = indexForm

/**
* @see \App\Http\Controllers\Admin\Pricing\CompetitorController::search
* @see app/Http/Controllers/Admin/Pricing/CompetitorController.php:126
* @route '/pricing/competitors/search'
*/
export const search = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: search.url(options),
    method: 'get',
})

search.definition = {
    methods: ["get","head"],
    url: '/pricing/competitors/search',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\Pricing\CompetitorController::search
* @see app/Http/Controllers/Admin/Pricing/CompetitorController.php:126
* @route '/pricing/competitors/search'
*/
search.url = (options?: RouteQueryOptions) => {
    return search.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Pricing\CompetitorController::search
* @see app/Http/Controllers/Admin/Pricing/CompetitorController.php:126
* @route '/pricing/competitors/search'
*/
search.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: search.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Pricing\CompetitorController::search
* @see app/Http/Controllers/Admin/Pricing/CompetitorController.php:126
* @route '/pricing/competitors/search'
*/
search.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: search.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\Pricing\CompetitorController::search
* @see app/Http/Controllers/Admin/Pricing/CompetitorController.php:126
* @route '/pricing/competitors/search'
*/
const searchForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: search.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Pricing\CompetitorController::search
* @see app/Http/Controllers/Admin/Pricing/CompetitorController.php:126
* @route '/pricing/competitors/search'
*/
searchForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: search.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Pricing\CompetitorController::search
* @see app/Http/Controllers/Admin/Pricing/CompetitorController.php:126
* @route '/pricing/competitors/search'
*/
searchForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: search.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

search.form = searchForm

/**
* @see \App\Http\Controllers\Admin\Pricing\CompetitorController::settings
* @see app/Http/Controllers/Admin/Pricing/CompetitorController.php:166
* @route '/pricing/competitors/settings'
*/
export const settings = (options?: RouteQueryOptions): RouteDefinition<'patch'> => ({
    url: settings.url(options),
    method: 'patch',
})

settings.definition = {
    methods: ["patch"],
    url: '/pricing/competitors/settings',
} satisfies RouteDefinition<["patch"]>

/**
* @see \App\Http\Controllers\Admin\Pricing\CompetitorController::settings
* @see app/Http/Controllers/Admin/Pricing/CompetitorController.php:166
* @route '/pricing/competitors/settings'
*/
settings.url = (options?: RouteQueryOptions) => {
    return settings.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Pricing\CompetitorController::settings
* @see app/Http/Controllers/Admin/Pricing/CompetitorController.php:166
* @route '/pricing/competitors/settings'
*/
settings.patch = (options?: RouteQueryOptions): RouteDefinition<'patch'> => ({
    url: settings.url(options),
    method: 'patch',
})

/**
* @see \App\Http\Controllers\Admin\Pricing\CompetitorController::settings
* @see app/Http/Controllers/Admin/Pricing/CompetitorController.php:166
* @route '/pricing/competitors/settings'
*/
const settingsForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: settings.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PATCH',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Pricing\CompetitorController::settings
* @see app/Http/Controllers/Admin/Pricing/CompetitorController.php:166
* @route '/pricing/competitors/settings'
*/
settingsForm.patch = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: settings.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PATCH',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

settings.form = settingsForm

/**
* @see \App\Http\Controllers\Admin\Pricing\CompetitorController::store
* @see app/Http/Controllers/Admin/Pricing/CompetitorController.php:140
* @route '/pricing/competitors'
*/
export const store = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

store.definition = {
    methods: ["post"],
    url: '/pricing/competitors',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Admin\Pricing\CompetitorController::store
* @see app/Http/Controllers/Admin/Pricing/CompetitorController.php:140
* @route '/pricing/competitors'
*/
store.url = (options?: RouteQueryOptions) => {
    return store.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Pricing\CompetitorController::store
* @see app/Http/Controllers/Admin/Pricing/CompetitorController.php:140
* @route '/pricing/competitors'
*/
store.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Pricing\CompetitorController::store
* @see app/Http/Controllers/Admin/Pricing/CompetitorController.php:140
* @route '/pricing/competitors'
*/
const storeForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Pricing\CompetitorController::store
* @see app/Http/Controllers/Admin/Pricing/CompetitorController.php:140
* @route '/pricing/competitors'
*/
storeForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(options),
    method: 'post',
})

store.form = storeForm

/**
* @see \App\Http\Controllers\Admin\Pricing\CompetitorController::tracked
* @see app/Http/Controllers/Admin/Pricing/CompetitorController.php:198
* @route '/pricing/competitors/{competitor}/tracked'
*/
export const tracked = (args: { competitor: string | { id: string } } | [competitor: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'patch'> => ({
    url: tracked.url(args, options),
    method: 'patch',
})

tracked.definition = {
    methods: ["patch"],
    url: '/pricing/competitors/{competitor}/tracked',
} satisfies RouteDefinition<["patch"]>

/**
* @see \App\Http\Controllers\Admin\Pricing\CompetitorController::tracked
* @see app/Http/Controllers/Admin/Pricing/CompetitorController.php:198
* @route '/pricing/competitors/{competitor}/tracked'
*/
tracked.url = (args: { competitor: string | { id: string } } | [competitor: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { competitor: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { competitor: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            competitor: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        competitor: typeof args.competitor === 'object'
        ? args.competitor.id
        : args.competitor,
    }

    return tracked.definition.url
            .replace('{competitor}', parsedArgs.competitor.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Pricing\CompetitorController::tracked
* @see app/Http/Controllers/Admin/Pricing/CompetitorController.php:198
* @route '/pricing/competitors/{competitor}/tracked'
*/
tracked.patch = (args: { competitor: string | { id: string } } | [competitor: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'patch'> => ({
    url: tracked.url(args, options),
    method: 'patch',
})

/**
* @see \App\Http\Controllers\Admin\Pricing\CompetitorController::tracked
* @see app/Http/Controllers/Admin/Pricing/CompetitorController.php:198
* @route '/pricing/competitors/{competitor}/tracked'
*/
const trackedForm = (args: { competitor: string | { id: string } } | [competitor: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: tracked.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PATCH',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Pricing\CompetitorController::tracked
* @see app/Http/Controllers/Admin/Pricing/CompetitorController.php:198
* @route '/pricing/competitors/{competitor}/tracked'
*/
trackedForm.patch = (args: { competitor: string | { id: string } } | [competitor: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: tracked.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PATCH',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

tracked.form = trackedForm

/**
* @see \App\Http\Controllers\Admin\Pricing\CompetitorController::destroy
* @see app/Http/Controllers/Admin/Pricing/CompetitorController.php:152
* @route '/pricing/competitors/{competitor}'
*/
export const destroy = (args: { competitor: string | { id: string } } | [competitor: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

destroy.definition = {
    methods: ["delete"],
    url: '/pricing/competitors/{competitor}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\Admin\Pricing\CompetitorController::destroy
* @see app/Http/Controllers/Admin/Pricing/CompetitorController.php:152
* @route '/pricing/competitors/{competitor}'
*/
destroy.url = (args: { competitor: string | { id: string } } | [competitor: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { competitor: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { competitor: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            competitor: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        competitor: typeof args.competitor === 'object'
        ? args.competitor.id
        : args.competitor,
    }

    return destroy.definition.url
            .replace('{competitor}', parsedArgs.competitor.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Pricing\CompetitorController::destroy
* @see app/Http/Controllers/Admin/Pricing/CompetitorController.php:152
* @route '/pricing/competitors/{competitor}'
*/
destroy.delete = (args: { competitor: string | { id: string } } | [competitor: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

/**
* @see \App\Http\Controllers\Admin\Pricing\CompetitorController::destroy
* @see app/Http/Controllers/Admin/Pricing/CompetitorController.php:152
* @route '/pricing/competitors/{competitor}'
*/
const destroyForm = (args: { competitor: string | { id: string } } | [competitor: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: destroy.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Pricing\CompetitorController::destroy
* @see app/Http/Controllers/Admin/Pricing/CompetitorController.php:152
* @route '/pricing/competitors/{competitor}'
*/
destroyForm.delete = (args: { competitor: string | { id: string } } | [competitor: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: destroy.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

destroy.form = destroyForm

/**
* @see \App\Http\Controllers\Admin\Pricing\CompetitorController::refresh
* @see app/Http/Controllers/Admin/Pricing/CompetitorController.php:188
* @route '/pricing/competitors/refresh'
*/
export const refresh = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: refresh.url(options),
    method: 'post',
})

refresh.definition = {
    methods: ["post"],
    url: '/pricing/competitors/refresh',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Admin\Pricing\CompetitorController::refresh
* @see app/Http/Controllers/Admin/Pricing/CompetitorController.php:188
* @route '/pricing/competitors/refresh'
*/
refresh.url = (options?: RouteQueryOptions) => {
    return refresh.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Pricing\CompetitorController::refresh
* @see app/Http/Controllers/Admin/Pricing/CompetitorController.php:188
* @route '/pricing/competitors/refresh'
*/
refresh.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: refresh.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Pricing\CompetitorController::refresh
* @see app/Http/Controllers/Admin/Pricing/CompetitorController.php:188
* @route '/pricing/competitors/refresh'
*/
const refreshForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: refresh.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Pricing\CompetitorController::refresh
* @see app/Http/Controllers/Admin/Pricing/CompetitorController.php:188
* @route '/pricing/competitors/refresh'
*/
refreshForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: refresh.url(options),
    method: 'post',
})

refresh.form = refreshForm

const competitors = {
    index: Object.assign(index, index),
    search: Object.assign(search, search),
    settings: Object.assign(settings, settings),
    store: Object.assign(store, store),
    tracked: Object.assign(tracked, tracked),
    destroy: Object.assign(destroy, destroy),
    refresh: Object.assign(refresh, refresh),
}

export default competitors